import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading:false,
        formConfig:{},
        curSystems:[],
        wxhideAllNonBaseMenuItem: false
    },
    mutations: {
        changeLoading(state, val){
            state.loading = val
        },
        saveFormConfig(state, config){
            state.formConfig = config;
        },
        saveCurSystems(state, curSystems){
            state.curSystems = curSystems
        },
        changeWxhideAllNonBaseMenuItem(value) {
          this.wxhideAllNonBaseMenuItem = value;
        }
    },
    actions: {

    },
    modules: {
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js